export function getEmailLink(feature: any): string {
  const email = 'map-services@bosch.com'
  const subject = `Feature ID: ${feature.id}`
  const body = `Report time: ${new Date()}%0D%0D Link: ${encodeURIComponent(window.location.href)}%0D%0DPls describe your issue here:%0D%0D%0D%0D%0D%0D%0D%0DPls add the raw feature data below by copy paste the raw field: %0D%0D `
  return `mailto:${email}?subject=${subject}&body=${body}`
}
